<template>
  <div class="navBar">
    <div class="container width1000">
      <el-menu class="el-menu-demo"
               mode="horizontal">
        <el-menu-item v-for="(item,index) in navlist.menus"
                      :key="index"
                      :index="index+''"
                      style="border:none"
                      :class="activedNum>1&&item.menuId==currentNum?'is-active':''"
                      @click="change(item.menuId)">{{item.name}}</el-menu-item>

      </el-menu>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      currentNum: "",
      // navlist: [
      //   {
      //     id: 1,
      //     name: '新闻中心'
      //   },
      //   {
      //     id: 2,
      //     name: '爱心联盟'
      //   },
      //   {
      //     id: 3,
      //     name: '爱心基地'
      //   },
      //   {
      //     id: 4,
      //     name: '慈善文化'
      //   },
      //   {
      //     id: 5,
      //     name: '慈善中国基金'
      //   },
      //   {
      //     id: 6,
      //     name: '最美志愿者'
      //   },
      //   {
      //     id: 7,
      //     name: '中华名医'
      //   },
      //   {
      //     id: 8,
      //     name: '宗教慈善'
      //   },
      //   {
      //     id: 9,
      //     name: '环球慈善'
      //   }
      // ]


    }
  },
  props: ['navlist', 'activedNum'],

  mounted () {
    this.currentNum = this.activedNum;

  },
  methods: {
    change (menuId) {
      this.currentNum = menuId;
      window.location.href = "/h5/index.html?menuId=" + menuId;
    }
  },
  watch: {
    navlist (val, oldVal) {
      this.navlist = val;
    },
    activedNum (val, oldVal) {
      this.currentNum = val;
    }
  }
}
</script>
<style lang="less">
.navBar {
  margin-top: 20px;
  background: #e60012;
  line-height: 55px;
  //height: 55px;
  .el-dropdown-menu__item--divided:before,
  .el-menu,
  .el-menu--horizontal > .el-menu-item:focus,
  .el-menu--horizontal > .el-menu-item:hover,
  // .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  //   background: #e60012;
  //   color: #fff;
  // }
  .el-menu--horizontal > .el-menu-item.is-active {
    border: none;
    background: #cc0000;
    color: #fff;
  }
  .el-menu--horizontal {
    border: none;
    background: #e60012;
  }
  .el-menu--horizontal > .el-menu-item {
    line-height: 55px;
    height: 55px;
    color: #fff;
  }
  .actived {
    background: #cc0000;
  }
}
</style>

